
import { IGetNeuralNetworkPredictionParameters } from "./IGetNeuralNetworkPredictionParameters";


export class GetNeuralNetworkPredictionParameters implements IGetNeuralNetworkPredictionParameters
{
    indicatorId: number = 0;
    fromDate: Date = new Date();
    toDate: Date = new Date();
    maxPoints: number = 0;
}
